// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { Term } from '../models';
import { TermCreate } from '../models';
import { TermEdit } from '../models';
import { TermList } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * ProfessionalActivityTaxonomyApi - axios parameter creator
 * @export
 */
export const ProfessionalActivityTaxonomyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete taxonomy term.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/taxonomy/professional-activity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create taxonomy term.
         * @param {TermCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: TermCreate, options: any = {}): RequestArgs {
            const localVarPath = `/v1/taxonomy/professional-activity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit taxonomy term.
         * @param {string} id 
         * @param {TermEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: TermEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/taxonomy/professional-activity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get taxonomy term list.
         * @param {string} [title] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(title?: string, order?: 'ASC' | 'DESC', offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/v1/taxonomy/professional-activity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfessionalActivityTaxonomyApi - functional programming interface
 * @export
 */
export const ProfessionalActivityTaxonomyApiFp = function(configuration?: Configuration) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete taxonomy term.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ProfessionalActivityTaxonomyApiAxiosParamCreator(configuration)._delete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create taxonomy term.
         * @param {TermCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: TermCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Term> {
            const localVarAxiosArgs = ProfessionalActivityTaxonomyApiAxiosParamCreator(configuration).create(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit taxonomy term.
         * @param {string} id 
         * @param {TermEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: TermEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Term> {
            const localVarAxiosArgs = ProfessionalActivityTaxonomyApiAxiosParamCreator(configuration).edit(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get taxonomy term list.
         * @param {string} [title] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(title?: string, order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermList> {
            const localVarAxiosArgs = ProfessionalActivityTaxonomyApiAxiosParamCreator(configuration).list(title, order, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProfessionalActivityTaxonomyApi - factory interface
 * @export
 */
export const ProfessionalActivityTaxonomyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete taxonomy term.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any) {
            return ProfessionalActivityTaxonomyApiFp(configuration)._delete(id, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create taxonomy term.
         * @param {TermCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: TermCreate, options?: any) {
            return ProfessionalActivityTaxonomyApiFp(configuration).create(body, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit taxonomy term.
         * @param {string} id 
         * @param {TermEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: TermEdit, options?: any) {
            return ProfessionalActivityTaxonomyApiFp(configuration).edit(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get taxonomy term list.
         * @param {string} [title] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(title?: string, order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
            return ProfessionalActivityTaxonomyApiFp(configuration).list(title, order, offset, limit, options)(axios, basePath);
        },
    };
};

/**
 * ProfessionalActivityTaxonomyApi - object-oriented interface
 * @export
 * @class ProfessionalActivityTaxonomyApi
 * @extends {BaseAPI}
 */
export class ProfessionalActivityTaxonomyApi extends BaseAPI {
    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Delete taxonomy term.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityTaxonomyApi
     */
    public _delete(id: string, options?: any) {
        return ProfessionalActivityTaxonomyApiFp(this.configuration)._delete(id, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Create taxonomy term.
     * @param {TermCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityTaxonomyApi
     */
    public create(body?: TermCreate, options?: any) {
        return ProfessionalActivityTaxonomyApiFp(this.configuration).create(body, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Edit taxonomy term.
     * @param {string} id 
     * @param {TermEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityTaxonomyApi
     */
    public edit(id: string, body?: TermEdit, options?: any) {
        return ProfessionalActivityTaxonomyApiFp(this.configuration).edit(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get taxonomy term list.
     * @param {string} [title] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityTaxonomyApi
     */
    public list(title?: string, order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
        return ProfessionalActivityTaxonomyApiFp(this.configuration).list(title, order, offset, limit, options)(this.axios, this.basePath);
    }

}
